import React, { useEffect, useState, Fragment } from "react";
import Layout from "../Components/Reuseable/layout";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import Cookies from "js-cookie";
import { Accordion } from "react-bootstrap";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// import "./RaceCardNew.css"; // Import NEW CSS
import Justsponsor from "./justsponser";
import Lottie from "lottie-react";
import { useLocation, useNavigate } from "react-router-dom";
import Animate from "../assets/loader.json";
import CalenderComponent from "../Components/Home/Components/Calendar";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { fetchracecardscreen } from "../redux/getReducer/getracecardscreen";
import { fetchCalender } from "../redux/getReducer/getCalender";
import headerIcon from "../../Webiste/assets/data1/image 4.png";
import RecentActivitiesCard from "../Components/Home/Components/RecentActivitiesCard";
import UpcomingRaceCard from "../Components/Home/Components/UpcomingRaceCard";
import { getRaceStatusColor } from "../service/raceStatusColor";
export default function Racecardscreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const [DateTobeDone, SetDateTobeDone] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [myData, setmyData] = useState(new Date());
  const { data: racecardscreen, status } = useSelector((state) => state.racecardscreen);
  const { data: CalenderData } = useSelector((state) => state.CalenderData);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);

  // Logic Preserved
  const GetDates = () => {
    var start = new Date();
    var end = new Date(start);
    end.setDate(start.getDate() + 3);
    let Dates = [];
    var loop = new Date(start);
    let i = 0;
    while (loop <= end) {
      if (i == 0) {
        var newDates = loop.setDate(loop.getDate() + i);
        loop = new Date(newDates);
        Dates.push(moment(loop).format("YYYY-MM-DD"));
      } else {
        var newDates = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDates);
        Dates.push(moment(loop).format("YYYY-MM-DD"));
      }
      i++;
    }
    SetDateTobeDone(Dates);
    return Dates;
  };

  useEffect(() => {
    dispatch(fetchracecardscreen({ start: moment().format("YYYY-MM-DD") }));
    dispatch(fetchCalender());
    SetDateTobeDone(GetDates());
  }, [dispatch]);

  // Auto-select best date logic
  useEffect(() => {
    if (CalenderData && CalenderData.length > 0 && !hasAutoSelected) {
      const today = moment().endOf('day');
      const raceDates = CalenderData.map(item => moment(item.start));

      const pastOrTodayRaces = raceDates.filter(d => d.isSameOrBefore(today));

      let targetDate = null;
      if (pastOrTodayRaces.length > 0) {
        targetDate = moment.max(pastOrTodayRaces).toDate();
      } else {
        targetDate = moment.min(raceDates).toDate();
      }

      if (targetDate && myData.toDateString() === new Date().toDateString()) {
        if (myData.toDateString() !== targetDate.toDateString()) {
          setmyData(targetDate);
          dispatch(fetchracecardscreen({ start: moment(targetDate).format("YYYY-MM-DD") }));
        }
      }
      setHasAutoSelected(true);
    }
  }, [CalenderData, hasAutoSelected, myData, dispatch]);

  const AllTime = (TimeData) => {
    if (TimeData.length === 0) return "";
    let FirstTime = moment(TimeData[0].StartTime).format("h:mm");
    let LastTime = moment(TimeData[TimeData.length - 1].StartTime).format("h:mm");
    return `${FirstTime} ${t("To")} ${LastTime}`;
  };

  function formatAMPM(date) {
    const DataDate = new Date(date);
    var hours = DataDate.getHours();
    var minutes = DataDate.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  const hexToRgba = (hex, opacity) => {
    if (!hex || !hex.startsWith("#")) return hex;
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  function handleRedirect(id) {
    navigate(`/race-detail?${id}`);
    setTimeout(() => window.scrollTo({ top: 1200, behavior: "smooth" }), 500);
  }

  return (
    <Fragment>
      {/* 1. Header Banner */}
      <div className="common-page-banner">
        <h1>{t("Race Card Overview")}</h1>
      </div>

      <div className="container-fluid new-main-wrapper main-wrapper-box">
        <div className="container">
          <div className="row new-layout-70-30">
            {/* LEFT SECTION */}
            <div className="col-lg-9">
              <div className="new-white-card">
                <div className="new-card-title">
                  <h3>{t("RACE CARD POST")}</h3>
                  <img src={headerIcon} alt="logo" style={{ width: '40px', opacity: '0.3', margin: '0 0 9px 0' }} />
                </div>

                <div className="new-custom-accordion">
                  {status === "loading" ? (
                    <Lottie animationData={Animate} style={{ width: "100px", margin: "auto" }} />
                  ) : racecardscreen?.length !== 0 ? (

                    <Accordion defaultActiveKey="0" flush className="mb-3">
                      {racecardscreen.map((singleracecourse, i) => (
                        <Accordion.Item eventKey={String(i)} style={{ border: "none" }} key={i}>

                          <Accordion.Header className="new-acc-header-wrapper">
                            <div className="new-acc-header-btn">
                              <div className="new-acc-left-info">
                                <span className="new-course-name">
                                  {cookiedata === "en"
                                    ? singleracecourse.TrackNameEn
                                    : singleracecourse.TrackNameAr}
                                </span>
                                <span className="new-course-date">
                                  {moment(myData).format("dddd, DD MMMM YYYY")}
                                </span>
                              </div>

                              <div className="new-acc-right-info">
                                <span className="new-race-stats">
                                  {t("Races")} {singleracecourse.RaceCourseData.length}
                                </span>
                                <span className="new-course-date">
                                  {AllTime(singleracecourse.RaceCourseData)}
                                </span>
                                <i className="fa fa-chevron-down"></i>
                              </div>
                            </div>
                          </Accordion.Header>

                          <Accordion.Body className="new-acc-body raceCardWrapper custom-scrollbar" style={{ overflow: 'auto !important', }}>
                            {singleracecourse.RaceCourseData.map((data, idx) => {
                              const baseColor = getRaceStatusColor(data.RaceStatus, data);
                              const lightColor = hexToRgba(baseColor, 0.5);

                              return (
                                <div
                                  key={idx}
                                  className="new-race-item-card"
                                  onClick={() => handleRedirect(data._id)}
                                >
                                  {/* Dynamic Sidebar */}
                                  <div className="new-race-sidebar">
                                    <div
                                      className="new-race-num-box"
                                      style={{ backgroundColor: baseColor }}
                                    >
                                      {t("Race")} {data.RaceNumber}
                                    </div>
                                    <div
                                      className="new-race-time-box"
                                      style={{ backgroundColor: lightColor, color: '#fff' }}
                                    >
                                      {formatAMPM(data.StartTime)}
                                    </div>
                                  </div>

                                  {/* Main Info */}
                                  <div className="new-race-main-info">
                                    <div className="new-race-top-row">
                                      <div className="new-race-heading">
                                        {cookiedata === "en"
                                          ? data.RaceNameModelData.NameEn
                                          : data.RaceNameModelData.NameAr}
                                      </div>
                                      <div className="new-runner-info">
                                        <span><b>{data?.Runners}</b> {t("Runner")}</span>
                                        <span><b>{data?.NonRunners}</b> {t("NonRunner")}</span>
                                      </div>
                                    </div>

                                    <div className="new-race-stats-grid">
                                      <div className="new-stat-item">
                                        <b>{t("Distance")}</b>
                                        <span>{data.TrackLengthData?.TrackLength || "-"}</span>
                                      </div>
                                      <div className="new-stat-item">
                                        <b>{t("Ground")}</b>
                                        <span>
                                          {cookiedata === "en"
                                            ? data.TrackLengthData?.GroundTypeModelData?.NameEn
                                            : data.TrackLengthData?.GroundTypeModelData?.NameAr}
                                        </span>
                                      </div>
                                      <div className="new-stat-item">
                                        <b>{t("RaceType")}</b>
                                        <span>
                                          {cookiedata === "en"
                                            ? data.RaceTypeModelData?.NameEn
                                            : data.RaceTypeModelData?.NameAr}
                                        </span>
                                      </div>
                                      <div className="new-stat-item">
                                        <b>{t("Total Prize")}</b>
                                        <span>
                                          {t("AED")} {(data?.FirstPrice || 0)
                                            + (data?.SecondPrice || 0)
                                            + (data?.ThirdPrice || 0)
                                            + (data?.FourthPrice || 0)
                                            + (data?.FifthPrice || 0)
                                            + (data?.SixthPrice || 0)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Accordion.Body>

                        </Accordion.Item>
                      ))}
                    </Accordion>

                  ) : (
                    <Skeleton count={3} height={60} />
                  )}
                </div>

              </div>
            </div>

            {/* RIGHT SIDEBAR: CALENDAR */}
            <div className="col-lg-3">
              <div className="new-sidebar-container">
                <div className="new-calendar-card">
                  <CalenderComponent setmyData={setmyData} forcedDate={myData} />
                </div>
                <div style={{ marginTop: '20px' }}>
                  <RecentActivitiesCard />
                  <UpcomingRaceCard />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <CoptRight />
    </Fragment>
  );
}